function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.252 19.394H3.03a.455.455 0 01-.454-.455v-3.112c0-.192.122-.363.303-.427a2.097 2.097 0 00.009-3.885.455.455 0 01-.303-.427V7.97c0-.248.198-.45.445-.455h16.222a.455.455 0 01.445.455v3.118a.455.455 0 01-.303.427 2.097 2.097 0 000 3.885.455.455 0 01.303.427v3.118a.455.455 0 01-.445.449zm-6.837-7.132a.3.3 0 01-.226-.17l-.772-1.642a.3.3 0 00-.543 0l-.772 1.643a.3.3 0 01-.226.169l-1.743.265a.3.3 0 00-.17.506l1.282 1.314a.3.3 0 01.081.258l-.3 1.84a.3.3 0 00.442.31L11 15.908a.3.3 0 01.29 0l1.533.847a.3.3 0 00.441-.31l-.3-1.84a.3.3 0 01.082-.258l1.281-1.314a.3.3 0 00-.17-.506l-1.742-.265z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.428 9.1a.455.455 0 01-.436-.318l-.97-2.797a.455.455 0 01.303-.576L15.61.024a.455.455 0 01.582.303l.96 2.967a.455.455 0 01-.151.497c-.606.463-.812 1.339-.549 2.23.23.788 1.097 1.515 1.819 1.515h.018c.25 0 .452.283.452.534 0 .251-.22.486-.47.486-1.143 0-2.5-.966-2.86-2.166-.35-1.032-.17-2.283.554-3.096L15.41 1.34 1.215 6.25l.597 1.74c.272.031.837.18 1.088.289.199.085.038 1.082-.178 1.082-.058-.003-1.035-.222-1.294-.261z"
});

function SvgStudiotour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgStudiotour;